import React from 'react'
import {browserHistory, Route, Router} from 'react-router'
import Dashboard from './Page/Dashboard/index'
import Recherche from './Page/Recherche/index'
import Message from './Page/Message/index'
import Cas from './Page/Cas/index'

export default _ =>
  <Router history={browserHistory}>
    <Route path="/sdd/dossier" component={Recherche}/>
    <Route path="/sdd/message" component={Message}/>
    <Route path="/sdd/bug" component={{...Cas}} searchName={'bug_'}/>
    <Route path="/sdd/developpement" component={{...Cas}} searchName={'developpement_'}/>
    <Route path="/sdd" component={Dashboard}/>
  </Router>



// WEBPACK FOOTER //
// ./app/App/Module/SDD/index.js